import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import List from './List';
import Info from './Info';

class LongTermCare extends React.PureComponent {
    render() {
        return (
            <Switch>
                <Route exact path='/longTermCare/list' component={List} />
                <Route exact path='/longTermCare/info/:id' component={Info} />
            </Switch>
        );
    }
}
export default LongTermCare;